import darkTheme from '../DarkTheme'
import WebThemeInterface from './WebThemeInterface'

const breakpoints = ['320px', '480px', '768px', '1024px', '1920px']

const webDarkTheme: WebThemeInterface = {
    ...darkTheme,
    breakpoints,
}

export default webDarkTheme
